import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { maskCep } from '@/lib/formatters';

import { UFS, type ClienteFormData } from './clienteFormUtils';

interface StepEnderecoProps {
  form: ClienteFormData;
  errors: Record<string, string>;
  set: (field: keyof ClienteFormData, value: string) => void;
}

export function StepEndereco({ form, errors, set }: StepEnderecoProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-6">
      <div className="space-y-1.5 sm:col-span-4">
        <Label htmlFor="endereco_logradouro">Logradouro</Label>
        <Input
          id="endereco_logradouro"
          autoFocus
          value={form.endereco_logradouro}
          onChange={(e) => set('endereco_logradouro', e.target.value)}
          placeholder="Rua, Avenida, etc."
          className={errors.endereco_logradouro ? 'border-destructive' : ''}
        />
      </div>
      <div className="space-y-1.5 sm:col-span-2">
        <Label htmlFor="endereco_numero">Número</Label>
        <Input
          id="endereco_numero"
          value={form.endereco_numero}
          onChange={(e) => set('endereco_numero', e.target.value)}
          placeholder="Nº"
        />
      </div>
      <div className="space-y-1.5 sm:col-span-3">
        <Label htmlFor="endereco_complemento">Complemento</Label>
        <Input
          id="endereco_complemento"
          value={form.endereco_complemento}
          onChange={(e) => set('endereco_complemento', e.target.value)}
          placeholder="Apto, Sala, etc."
        />
      </div>
      <div className="space-y-1.5 sm:col-span-3">
        <Label htmlFor="endereco_bairro">Bairro</Label>
        <Input
          id="endereco_bairro"
          value={form.endereco_bairro}
          onChange={(e) => set('endereco_bairro', e.target.value)}
          placeholder="Bairro"
        />
      </div>
      <div className="space-y-1.5 sm:col-span-3">
        <Label htmlFor="endereco_cidade">Cidade</Label>
        <Input
          id="endereco_cidade"
          value={form.endereco_cidade}
          onChange={(e) => set('endereco_cidade', e.target.value)}
          placeholder="Cidade"
        />
      </div>
      <div className="space-y-1.5 sm:col-span-1">
        <Label htmlFor="endereco_uf">UF</Label>
        <Select value={form.endereco_uf} onValueChange={(v) => set('endereco_uf', v)}>
          <SelectTrigger id="endereco_uf">
            <SelectValue placeholder="UF" />
          </SelectTrigger>
          <SelectContent>
            {UFS.map((uf) => (
              <SelectItem key={uf} value={uf}>{uf}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5 sm:col-span-2">
        <Label htmlFor="endereco_cep">CEP</Label>
        <Input
          id="endereco_cep"
          value={form.endereco_cep}
          onChange={(e) => set('endereco_cep', maskCep(e.target.value))}
          placeholder="00000-000"
        />
      </div>
    </div>
  );
}
